import styled from '@emotion/styled';
import { Box, Tab, Tabs, Button, Typography } from '@mui/material';

// Page Container
export const PageContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

// Tab Content Container with top margin
export const TabContentContainer = styled(Box)`
  margin-top: 12px;
`;

// Row container for search and filter
export const SearchFilterRow = styled(Box)`
  display: flex;
  align-items: center;
`;

// Filter popover header container
export const FilterPopoverHeader = styled(Box)``;

// Filter popover title row
export const FilterTitleRow = styled(Box)`
  display: flex;
  align-items: center;
`;

// Filter row with spacing (for dropdowns side by side)
export const FilterDropdownRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

// Filter section wrapper with bottom margin
export const FilterSection = styled(Box)`
  margin-bottom: 8px;
`;

// Date picker container
export const DatePickerContainer = styled(Box)``;

// Filter action buttons row
export const FilterActionRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
`;

// Filter label with bottom margin
export const FilterLabelWithMargin = styled(Typography)`
  font-family: 'Outfit', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: var(--subtext);
  margin-bottom: 8px;
`;

// Modern Tabs Styling
export const StyledTabs = styled(Tabs)`
  min-height: 44px;
  border-bottom: 1px solid #e0e0e0;

  & .MuiTabs-indicator {
    height: 3px;
    border-radius: 3px 3px 0 0;
    background: linear-gradient(90deg, #0f52ba 0%, #1976d2 100%);
  }

  & .MuiTabs-flexContainer {
    gap: 8px;
  }
`;

export const StyledTab = styled(Tab)<{ selected?: boolean }>`
  font-family: 'Outfit', sans-serif;
  font-size: 14px;
  font-weight: ${({ selected }) => (selected ? '600' : '400')};
  color: ${({ selected }) => (selected ? '#0f52ba' : '#75838a')};
  text-transform: none;
  min-height: 44px;
  padding: 12px 24px;
  border-radius: 8px 8px 0 0;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: #0f52ba;
    background-color: rgba(15, 82, 186, 0.04);
  }

  &.Mui-selected {
    color: #0f52ba;
    background-color: rgba(15, 82, 186, 0.08);
  }
`;

// Tab Panel Container
export const TabPanelContainer = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

// Grid Action Button (used in action columns)
export const GridActionButton = styled(Button)<{
  bgColor?: string;
  hoverBgColor?: string;
}>`
  height: 28px;
  min-width: 70px;
  padding: 4px 12px;
  background-color: ${({ bgColor }) => bgColor || '#0f52ba'};
  color: #ffffff;
  font-family: 'Outfit', sans-serif;
  font-size: 12px;
  font-weight: 500;
  text-transform: none;
  border-radius: 6px;

  &:hover {
    background-color: ${({ hoverBgColor }) => hoverBgColor || '#0d47a1'};
  }

  &:disabled {
    background-color: #b0bec5;
    color: #ffffff;
    cursor: not-allowed;
    pointer-events: auto;
  }
`;
